import PropTypes from 'prop-types'

const ManualDailyDeliveryStatus = ({ summary }) => {
	if (!summary) return null
	const percent = Math.max(0, Math.min(100, summary.percentage || 0))
	const color = percent === 100 ? '#15803d' : percent >= 85 ? '#b45309' : '#dc2626'
	const rows = [
		['Daily report emails sent', summary.emails],
		['Locations with every recipient sent', summary.locations],
		['Location email addresses sent', summary.locationAddresses],
		['Admin email addresses sent', summary.admins]
	]
	const update = summary.vgtUpdate
	return (
		<section className="space-y-3 rounded-xl border border-gray-200 bg-white p-4" aria-label="Today's daily email coverage">
			<h3 className="font-semibold text-gray-900">Daily Emails — {summary.sendDate}</h3>
			<p className="text-sm text-gray-600">Financial report date: {summary.reportDate}</p>
			<div role="progressbar" aria-label="Daily report emails sent" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} className="relative h-10 overflow-hidden rounded-lg bg-gray-100">
				<div className="absolute inset-y-0 left-0 transition-all" style={{ width: `${percent}%`, backgroundColor: color }} />
				<div className="absolute inset-0 flex items-center justify-center">
					<span className="rounded-md border-2 bg-white px-3 py-1 text-sm font-bold text-gray-700" style={{ borderColor: color }}>{percent}%</span>
				</div>
			</div>
			<dl className="space-y-2 text-sm">
				{rows.map(([label, counts]) => <div key={label} className="flex justify-between gap-3"><dt>{label}</dt><dd className="font-semibold">{counts?.sent || 0} / {counts?.expected || 0}</dd></div>)}
			</dl>
			<div className="border-t border-gray-200 pt-3 text-sm">
				<p className="font-semibold" style={{ color: update?.confirmed && update?.updatedToday ? '#15803d' : '#b45309' }}>VGT update: {update?.confirmed && update?.updatedToday ? 'Confirmed today' : 'Not confirmed today'}</p>
				<p className="mt-1 text-gray-600">{update?.locationsWithActivity || 0} locations with activity; 10 required. Import: {update?.successfulImport ? 'successful' : 'not confirmed'}.</p>
				{update?.updatedAt && <p className="mt-1 text-gray-600">Updated: {new Date(update.updatedAt).toLocaleString('en-US', { timeZone: summary.timezone })} ({summary.timezone}) · Batch #{update.batchId}</p>}
				{summary.sentBeforeLatestUpdateCount > 0 && <p className="mt-1 text-amber-800">{summary.sentBeforeLatestUpdateCount} reports were sent before the latest data update.</p>}
			</div>
			<p className="text-xs text-gray-500">Counts use successful provider sends, not inbox confirmation. Each location/recipient counts once. Each address counts once if it was sent at least one daily report. A location is complete when every expected recipient was sent its report.</p>
			<p className="text-sm font-semibold text-amber-800">Confirming sends another copy to recipients whose report was already sent. Queued or uncertain deliveries will not be duplicated.</p>
		</section>
	)
}

ManualDailyDeliveryStatus.propTypes = { summary: PropTypes.object }
ManualDailyDeliveryStatus.defaultProps = { summary: null }
export default ManualDailyDeliveryStatus
